import prayerGlovesImg from '../assets/prayer-gloves.jpg';

export const products = [
  {
    id: 1,
    name: 'Premium Ajwa Dates',
    price: 120,
    oldPrice: 150,
    category: 'food',
    image: 'https://images.pexels.com/photos/37417612/pexels-photo-37417612.jpeg?auto=compress&cs=tinysrgb&w=800',
    fallback: '🌴',
    halal: true,
    badge: 'BESTSELLER',
    description: 'Authentic organic Ajwa dates directly sourced from Medina Munawwarah.',
    rating: 4.9,
    reviews: 128,
  },
  {
    id: 2,
    name: 'Embroidered Prayer Gloves',
    price: 180,
    oldPrice: null,
    category: 'clothing',
    image: prayerGlovesImg,
    imageFit: 'contain',
    fallback: '🧤',
    halal: true,
    badge: 'NEW',
    description: 'Intricately hand-embroidered velvet gloves with traditional gold embroidery.',
    rating: 4.7,
    reviews: 45,
  },
  {
    id: 3,
    name: 'Premium Niqab',
    price: 150,
    oldPrice: 200,
    category: 'clothing',
    image: 'https://images.pexels.com/photos/18010956/pexels-photo-18010956.jpeg?auto=compress&cs=tinysrgb&w=800',
    fallback: '👗',
    halal: true,
    badge: 'SALE',
    description: 'Ultra-soft, breathable multi-layer white niqab tailored with Saudi chiffon.',
    rating: 4.8,
    reviews: 89,
  },
  {
    id: 4,
    name: 'Tasbih Prayer Beads',
    price: 95,
    oldPrice: null,
    category: 'accessories',
    image: 'https://images.pexels.com/photos/10973380/pexels-photo-10973380.jpeg?auto=compress&cs=tinysrgb&w=800',
    fallback: '📿',
    halal: true,
    badge: null,
    description: 'Hand-carved dark 99-bead tasbih with gold silk tassel.',
    rating: 4.9,
    reviews: 215,
  },
  {
    id: 5,
    name: 'Silk Hijab',
    price: 130,
    oldPrice: null,
    category: 'clothing',
    image: 'https://images.pexels.com/photos/15154961/pexels-photo-15154961.jpeg?auto=compress&cs=tinysrgb&w=800',
    fallback: '🧣',
    halal: true,
    badge: 'POPULAR',
    description: 'Pure Medina silk scarf woven for elegant sheen and all-day comfort.',
    rating: 4.8,
    reviews: 167,
  },
  {
    id: 6,
    name: 'Luxury Velvet Prayer Mat',
    price: 85,
    oldPrice: 110,
    category: 'accessories',
    image: 'https://images.pexels.com/photos/31009200/pexels-photo-31009200.jpeg?auto=compress&cs=tinysrgb&w=800',
    fallback: '🕌',
    halal: true,
    badge: 'SALE',
    description: 'Padded orthopedic prayer rug woven with Ottoman arch motifs.',
    rating: 4.6,
    reviews: 92,
  },
  {
    id: 7,
    name: 'Royal Oud Perfume',
    price: 250,
    oldPrice: null,
    category: 'fragrance',
    image: 'https://images.pexels.com/photos/35658144/pexels-photo-35658144.jpeg?auto=compress&cs=tinysrgb&w=800',
    fallback: '💐',
    halal: true,
    badge: 'PREMIUM',
    description: 'Concentrated 100% alcohol-free pure Dehn Al Oud oil.',
    rating: 5.0,
    reviews: 78,
  },
  {
    id: 8,
    name: 'Natural Organic Henna',
    price: 45,
    oldPrice: null,
    category: 'beauty',
    image: 'https://images.pexels.com/photos/34588508/pexels-photo-34588508.jpeg?auto=compress&cs=tinysrgb&w=800',
    fallback: '🎨',
    halal: true,
    badge: null,
    description: 'Freshly ground triple-sifted organic henna powder.',
    rating: 4.5,
    reviews: 56,
  },
];

export const categories = [
  { id: 'all', name: 'All Products', icon: '🛍️' },
  { id: 'food', name: 'Food & Dates', icon: '🌴' },
  { id: 'clothing', name: 'Clothing', icon: '👗' },
  { id: 'accessories', name: 'Accessories', icon: '📿' },
  { id: 'fragrance', name: 'Fragrance', icon: '💐' },
  { id: 'beauty', name: 'Beauty', icon: '🎨' },
];

export const heroSlides = [
  {
    id: 1,
    title: 'Curated Luxury Essentials',
    subtitle: 'From Medina Munawwarah',
    description: 'Discover timeless essentials handcrafted with tradition, sourced directly from Medina.',
    image: 'https://images.pexels.com/photos/34642006/pexels-photo-34642006.jpeg?auto=compress&cs=tinysrgb&w=1920',
    cta: 'Explore Now',
    link: '/collection',
  },
  {
    id: 2,
    title: 'Authentically Madinah',
    subtitle: 'Ethically Sourced Halal',
    description: 'Every product, a piece of Khayr for your home.',
    image: 'https://images.pexels.com/photos/37269396/pexels-photo-37269396.jpeg?auto=compress&cs=tinysrgb&w=1920',
    cta: 'Shop Collection',
    link: '/collection',
  },
  {
    id: 3,
    title: 'Global Express Shipping',
    subtitle: '100+ Countries Worldwide',
    description: 'Bringing Madinah excellence straight to your doorstep.',
    image: 'https://images.pexels.com/photos/37729307/pexels-photo-37729307.jpeg?auto=compress&cs=tinysrgb&w=1920',
    cta: 'Discover More',
    link: '/collection',
  },
];

export const medinaImage = 'https://images.pexels.com/photos/34642006/pexels-photo-34642006.jpeg?auto=compress&cs=tinysrgb&w=1000';
